import { lazy } from "react";

export const VisitsHistoryAsync = lazy(() => import("./VisitsHistory"));
